export default [
	'DFW',
	'Houston',
	'Central',
	'East',
	'Valley',
	'Austin',
	'San Antonio',
	'West',
	'Texas',
	'Texas & Surrounding States',
	'Anywhere in the US',
	'Other',
];